<style>
  #BtnDiv {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background: #282a39b0;
    padding: 10px;
    border-radius: 5px;
  }
</style>

<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Incoming Letter Form</h5>

    <button type="button" *ngIf="Letter_Form_Id=='0' && Selected_DataList_LetterRequestCustomer_Record.id == 0"
      (click)="openModal_Customer(templateCustomer)" class="btn btn-warning" style="margin-right: 5px;"> Search Customers <i
        class="fa fa-vcard"></i> </button>
    <button type="button" *ngIf="Letter_Form_Id=='0'"
      (click)="openModal_LetterRequestCustomer(templateLetterRequestCustomer)" class="btn btn-danger"
      style="margin-right: 5px;"> Attach to Letter <i class="fa fa-vcard"></i> </button>


    <br />
    <br />

    <div *ngIf="Data_Seleted_Customer.id>0">

      <form [formGroup]="AddNewLetter">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Request ID </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code_Code}}" />
          </div>
          <div class="form-group col-md-4" style="display: none;">
            <label for="exampleInputEmail1"> Letter Number </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Behfa Customer Code </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Customer Name </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>
        <br />
        <hr />
        <br />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Letter Subject </label>
            <select class="custom-select" formControlName="subject_id">
              <option value="0">--- Type Letter Subject ---</option>
              <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Letter Subject </label>
            <input formControlName="draftTitle" type="text" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_draftTitle().valid && get_Form_draftTitle().touched"
              class="form-text text-muted MyErrorRedColor">Enter the letter subject.</small>
          </div>

          <div class="form-group col-md-4" *ngIf="Letter_Form_Id=='0'">
            <label for="exampleInputEmail1"> Tracking Code </label>
            <input type="text" class="form-control" placeholder="Type here..." formControlName="codePeygiri" />
          </div>

          <div class="form-group col-md-4" *ngIf="Letter_Form_Id!='0'">
            <label for="exampleInputEmail1"> Tracking Code </label>
            <input type="text" class="form-control" value="{{codePeygiri}}" />
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Sender Salutation </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">Ms.</option>
              <option value="1" selected>Mr.</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Sender Name </label>
            <input formControlName="giver_name" type="text" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_giver_name().valid && get_Form_giver_name().touched"
              class="form-text text-muted MyErrorRedColor">Enter the sender name.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Sender Position </label>
            <input formControlName="giver_semat" type="text" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_giver_semat().valid && get_Form_giver_semat().touched"
              class="form-text text-muted MyErrorRedColor">Enter the sender position.</small>
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-4" style="display: none;">
            <label for="exampleInputEmail1"> Attachment </label>
            <select class="custom-select" formControlName="peyvast">
              <option selected value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Incoming Letter Number </label>
            <input formControlName="bazgashtBeNamehShomareh" type="text" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_bazgashtBeNamehShomareh().valid && get_Form_bazgashtBeNamehShomareh().touched"
              class="form-text text-muted MyErrorRedColor">Enter the incoming letter number.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Incoming Letter Date </label>
            <input formControlName="bazgashtBeNamehTarikh" type="text" class="form-control"
              #datepickerbazgashtBeNamehTarikh placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
              [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerbazgashtBeNamehTarikh"></ng-persian-datepicker>
          </div>
        </div>

        <br />
        <hr />
        <br />

        <div *ngIf="canEditMainForm" class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              Attachments
              <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                  class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
              class="form-control" placeholder="Type here...">
          </div>
        </div>

        <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
          class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>

        <br />

        <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>File</th>
                <th>Status</th>
                <th *ngIf="canEditMainForm">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of UploadImageSrc_List">

                <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>

                <td>

                  <a target="_blank" *ngIf="item.title.includes('.pdf')" href="{{BaseUrl}}File/Letter/{{item.title}}"
                    class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>

                  <a target="_blank" *ngIf="item.title.includes('.xls') || item.title.includes('.xlsx')"
                    href="{{BaseUrl}}File/Letter/{{item.title}}" class="btn btn-success"><i
                      class="fa fa-file-pdf-o"></i> PDF </a>

                  <img
                    *ngIf="!item.title.includes('.pdf') && !item.title.includes('.xls') && !item.title.includes('.xlsx')"
                    (click)="openModal(templateImage,item.title)" style="width: 150px;cursor: zoom-in;"
                    src="{{BaseUrl}}File/Letter/{{item.title}}" />
                </td>
                <td>
                  <p (click)="SetLetterRequestCustomerImageShow(item)" *ngIf="item.del" style="color: #489b39;">Visible
                    to Calibration Technician</p>
                  <p (click)="SetLetterRequestCustomerImageShow(item)" *ngIf="!item.del" style="color: crimson;">Hidden
                    from Calibration Technician</p>
                </td>
                <td *ngIf="canEditMainForm">
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;"
                          (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                      </div>
                    </div>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </form>

      <br />
      <br />

    </div>


    <br />
    <br />

    <div id="BtnDiv">

      <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />

      <ng-container *ngFor="let item of Data_List_Order">

        <button *ngIf="item.submit && !InProccessing" type="button" (click)="OpenOrderDialog(templateOrder,item)"
          [disabled]="!AddNewLetter.valid" [class]="item.cls" style="margin-right: 5px;"> <i [class]="item.icon"></i>
          {{item.title}} </button>
        <button *ngIf="item.hasRefer && !item.submit && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-right: 5px;"><i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-right: 5px;"> <i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && item.copy && !InProccessing" type="button"
          [routerLink]="['/LetterRequestCustomerForm',{draft:Selected_DataList_LetterRequestCustomer_Record.id}]"
          [class]="item.cls" style="margin-right: 5px;"> <i [class]="item.icon"></i> {{item.title}} </button>

      </ng-container>


      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="ReadHistory_Letter()" type="button"
        class="btn btn-warning" style="margin-right: 5px;"> <i class="fa fa-file-text"></i> Letter Details </button>

      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="OpenNoteDialog(templateComment)" type="button"
        class="btn btn-success" style="margin-right: 5px;"> <i class=" fa fa-sticky-note-o"></i> Submit Comment </button>


    </div>

    <br />
    <br />


  </div>
</div>

<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Letter Details '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">Referral History</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">Letter Attachments</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">Referral Workflow</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button"
            (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>Delete Latest
            Referral</button>
        </div>
        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast"
              [DataList_Peyvast]="DataList_Peyvast"></app-LetterRequestCustomerPeyvast>

          </div>
        </div>
        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div>
              <app-LetterRequestCustomerTreeHistory [DataList_History]="DataList_History">
              </app-LetterRequestCustomerTreeHistory>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>

  </div>



</div>



<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Customer List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Behfa Customer Code</th>
              <th>Customer Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Letter Number </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Outgoing Letter Number for Customer <b>'{{Letter_Form_Code}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateLetterRequestCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Letter Information List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterRequestCustomer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Letter Number </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Letter Subject </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Letter Number</th>
              <th>Letter Type</th>
              <th>Customer Name</th>
              <th>Letter Subject </th>
              <th>Recipient Name</th>
              <th>Recipient Position</th>
              <th>Sender User</th>
              <th>Recipient User</th>
              <th>Status</th>
              <th>Message</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_customer_LetterRequestCustomer:'customer'
            |filter:Search_code_LetterRequestCustomer:'code'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                        |filter:Search_code_LetterRequestCustomer:'code'
                        |filter:Search_customer_LetterRequestCustomer:'customer').length
                      }
            ">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.giver_name}}</td>
              <td>{{item.giver_semat}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastGiver}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastOrder}}</td>
              <td (click)="Set_Selected_LetterRequestCustomer(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_LetterRequestCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_LetterRequestCustomer()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomer.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12" *ngIf="Selected_Order_Operation.hasRefer || Selected_Order_Operation.submit">
        <label for="exampleInputEmail1">Recipient</label>
        <select class="custom-select" [(ngModel)]="SelectedLetterRole">
          <option value="0">Select</option>
          <option *ngFor="let item of Data_list_LetterRole" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,Selected_Order_Operation)"> Submit and Register </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Submit a New Customer Comment for Customer '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="Type here...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      Submit and Register </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">Close</button>
  </div>
</ng-template>
